<template>
<header class="qb-color-1">
    <div class="logo">
        <router-link to='/'><img alt="Vue logo" src="@/assets/logo-florestabranco-xs.png"></router-link>
    </div>
    <form class="search" v-on:submit.prevent="buscarProduto">
        <div class="input-search">
            <input type="text" v-model="busca" placeholder="Buscar produtos..." />
            <button class="search-ico" style="height: 33px;" ><search class="md-28 white"/></button>
        </div>
    </form>
    <div class="menu-desktop">
      <!-- <div class="home">
        <router-link to="/"><span><Home title="Início" class="md-36 white" /></span></router-link>
      </div> -->
      <div v-if="vendedor">
        <Account style="cursor:pointer;"  @click="openEditWindow();" class="md-36 white" />
      </div>
      <div v-else></div>
      <div v-if="vendedor" style="margin-left:-10px;" class="white">
        <small>CLIENTE</small><br>
        <strong>{{this.nomeCliente[0]}}</strong>
      </div>
      <div v-else></div>
      <div v-if="vendedor">
        <CreditCard class="md-36 white" />
      </div>
      <div style="margin-left:-10px;" class="white" v-if="vendedor"> 
        <small>PAGAMENTO</small><br>
        <strong>{{this.forma_pagamento}}</strong>
      </div>
     <div v-else></div>
      <div class="cart" style="order: 0;">
        <router-link to="/carrinho"><span><basket title="Carrinho" class="md-36 white"/></span></router-link>
      </div>
      <div class="user" style="order: 1;">
        <v-popover offset="16" >
          <avatar :username="userName" :size=36></avatar>
          <template slot="popover">
            <div>
              <span>Bem vindo! {{ userName }}</span>
              <ul style="list-style: none;">
                <li v-if="this.gestor =='S'">
                  <router-link style="color:white;" to='/acessos'> 
                    Acessos
                  </router-link>
                </li>
                <li  @click="logout()">
                 <span style="color:#fff;cursor: pointer;">Sair</span>
                </li>
              </ul>
            </div>
          </template>
        </v-popover>
        
      </div>
      <div class="orders">
        <router-link to='/ultimos-pedidos'><span ><Receipt title="Últimos Pedidos" class="md-36 white" /></span></router-link>
      </div>
      <div class="orders">
        <router-link to="/relatorio">
          <span><CashUsd title="Relatório" class="md-36 white"/></span>
        </router-link>
      </div>
    </div>
    <modal key="edit" name="edit" v-if="vendedor" :adaptive="true" height="auto" :resizable="true" :scrollable="true"  style="padding:10px;" display="block">
      <div class="vinculo">
        <button @click="closeModal()" style="color:black;float:right;">X</button>
        <p style="font-weight: 600;font-size: 20px;margin-left:20px;">VINCULAR CLIENTE</p>    
        <v-select v-model="selected" :options="options" :value="$store.myValue" @input="SetCliente">
        </v-select>
        <button @click="vincularCliente()" class="btn btn-primary btn-add-vinculo">
          Vincular
        </button>   
      </div>
    </modal>
    <div v-if="vendedor" class="clienteVinculado white">
      <Account @click="openEditWindow();" style="cursor: pointer;"/>{{nomeCliente[0]}}
     <CreditCard /> {{forma_pagamento}}
    </div>
</header>
</template>

<script>
//import axios from 'axios';
import Basket from "vue-material-design-icons/Basket.vue";
import Home from "vue-material-design-icons/Home.vue";
import Search from "vue-material-design-icons/Magnify.vue";
import Receipt from "vue-material-design-icons/Receipt.vue";
import CashUsd from "vue-material-design-icons/CashUsd.vue";
import Avatar from 'vue-avatar';
import CreditCard from "vue-material-design-icons/CreditCard.vue";
import Account from "vue-material-design-icons/Account.vue";
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import axios from 'axios';



import { baseApiUrl, userKey } from "@/global";
export default {
  name: 'Header',
  components:{
    Basket,
    Search,
    Avatar,
    CreditCard,
    Account,
    Home,
    vSelect,
    CashUsd,
    Receipt
  },
  data(){
    return{
      selected: {label:'Selecione um Cliente', id:0},
      options: [],
      usuarios:[],
      vendedor: false,
      userName: '',
      gestor:'',
      nomeAux:'',
      nomeCliente:'',
      forma_pagamento:'',
      tipo_acesso: '',
      busca: ''
    }
  },
  methods:{
    buscarProduto(){
      if(this.busca)
        this.$router.push({ name: 'lista', query:{ 
          marcas: '',//this.$route.query.marcas, 
          params: this.busca, 
          pagina: 1,
          idCategoria: '',//this.$route.query.idCategoria,
          ofertas: '',//this.$route.query.ofertas,
          novidades: '',//this.$route.query.novidades
          }})
      this.busca = "";
    },
    carregaClientes(){
        const json = localStorage.getItem(userKey);
        const userData = JSON.parse(json);
        axios.get(`${baseApiUrl}/login/clientes/?userId=${userData.vendedor}`)
        .then(res => {
            this.usuarios = res.data;
            this.usuarios.forEach(element => {
                this.options.push({'label': element.id + ' ' + element.description + ' ' + element.doc , 'id': element.id, 'nome':element.description });
            });
        });            
    },  
    openEditWindow(){
      this.$modal.show('edit');
    },
    closeModal(){
      this.$modal.hide('edit');
     },
    vincularCliente(){
        localStorage.setItem('cliente_vinculado', JSON.stringify({"id":this.cliente, "nome":this.nomeAux}));
        this.nomeCliente = this.nomeAux;
        alert("CLIENTE ALTERADO PARA "+ this.nomeAux);
        // window.location.reload();
        window.location.replace('/pedido');
    },
    SetCliente (cliente)
    {
        const id =(cliente == null ? 0 : cliente.id);
        this.cliente = id;
        this.nomeAux = cliente.nome;
    },
    logout(){
      localStorage.removeItem(userKey);
      localStorage.removeItem('cliente_vinculado');
      this.$store.commit('removeUser');
      this.$router.push({name: 'home'});
    }
  },
  created(){
    this.carregaClientes();
    const json = localStorage.getItem(userKey);
    const userData = JSON.parse(json);
    // console.log(userData.tipoAcesso);
    this.userName = userData.userName;
    this.gestor = userData.gestor;
    this.tipoAcesso = userData.tipoAcesso;
    if(userData.tipoAcesso == "V"){
      const cliente = JSON.parse(localStorage.getItem('cliente_vinculado'));
      const pagto = JSON.parse(localStorage.getItem('forma_pagamento'));
      this.forma_pagamento = pagto.label;
      this.nomeCliente = cliente.nome.split(" ");
      this.vendedor = true;
    }
  }
}
</script>

<style >
.tooltip {
  display: block !important;
  z-index: 10000;
}
.clienteVinculado{
  display: none;
}
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #006f3a;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #009d43;
  color: #fff;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #009d43;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

.cart{
  display: inherit;
  order:2;
}
.user{
  display: flex;
  align-items: center;
}
.orders{
  display: flex;align-items: center;font-size: 14px; font-weight: 700;
}
header{
  display: flex;
  align-items: center;
  justify-content: center;
  /*background-image: url('~@/assets/peixes-top.png');*/
  background-repeat: no-repeat;
  background-position: right;
}

.logo{
  text-align: center;
  padding: 0.5em;
}

.logo img{
  width: 100px;
}

.search{
  width: 30%;
  background-color: none;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-search{
    width: 95%;
    display: flex;
    align-items: center;
}

.input-search input{
  padding-left: 16px;
  width: 100%;
  border:none;
  border-radius: 2px 0 0px 2px;
  height: 33px;
}

.material-design-icon.md-36 {
  font-size: 36px;
  height: 0.85em;
}

.material-design-icon.md-28 {
  font-size: 28px;
  height: 0.85em;
}

.white{
  color: #fff
}

.search-ico{
  border: none;
  background-color: #009d43;

}
.menu-desktop{
  display: flex;justify-content: space-between;min-width: 400px;
  align-items: center;
}
@media screen and (max-width: 900px){
  .search{
    background-color: #006f3a;
    width: 100%;
    padding: 16px;
  }

  .input-search{
    width: 100%;
  }
  header{
    display: inherit;
  }
  .cart{
    display: none;
  }

  .search-ico{
    background-color: #009d43;
    border: 1px solid #009d43;
  }
}

@media screen and (max-width: 900px) and (min-width: 600px) {
 
  .logo img{
    max-height: 100px;
  }
}

@media screen and (max-width: 900px) {
 .menu-desktop{
   display: none;
 }
 .color-bg{
   background-color: #006f3a;
 }
  .clienteVinculado{
    display: block;
    text-align:right;
    padding-right:15px;
  }
}
</style>